import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import { Dropdown, Button, Icon, Popover } from 'antd';
import { css } from 'emotion';
import { colorIconBlack, popoverErrorStyle } from 'styles/base';

// Tell eslint that Array is a global var
/*global Array */

/**
 * ToolbarItem
 */
export default class ToolbarItem extends React.Component {

    static propTypes = {
        title: PropTypes.oneOfType([PropTypes.string, PropTypes.obj]),
        className: PropTypes.string,
        clickHandler: PropTypes.func,
        enabled: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
        disabledMessage: PropTypes.string, // popover message for when item is disabled
        selectionDependent: PropTypes.bool,
        selectedItems: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        selectedItem: PropTypes.string,
        lastSelectedItem: PropTypes.string,
        textOnly: PropTypes.bool, // show only text, no icon
        showText: PropTypes.bool, // show icon and text
        button: PropTypes.bool, // render as button
        dropdownButton: PropTypes.bool, // should render as a dropdown
        iconComponent: PropTypes.any, // Users can pass in fancy stacked font awesome icons if necessary
        children: PropTypes.any
    };

    onClick = () => {
        if (this.props.clickHandler) {
            // pass my selected items to the handler
            this.props.clickHandler(this.props.selectedItems, this.props.lastSelectedItem, this.props.selectedItem);
        }
    };

    getNumSelectedItems() {
        let numSelected = 0;
        const selectedItems = this.props.selectedItems;

        if (selectedItems !== undefined && selectedItems !== null) {
            if (Array.isArray(selectedItems)) {
                numSelected = selectedItems.length;
            } else {
                Object.keys(selectedItems).forEach(itemId => {
                    const item = selectedItems[itemId];
                    if (item) {
                        numSelected ++;
                    }
                });
            }
        }
        return numSelected;
    }

    render() {
        let enabled = false;
        if (!_.isNil(this.props.enabled)) {
            if (typeof(this.props.enabled) === 'boolean') {
                enabled = this.props.enabled;
            
            } else {
                enabled = this.props.enabled();
            }
        }
        if (this.props.selectionDependent) {
            enabled &= (this.getNumSelectedItems() > 0);
        }
        let onClick = () => {}; // do nothing
        if (enabled) {
            onClick = this.onClick;
        }
        const className = enabled ? '' : 'disabled';
        let toolComponent = null;

        let iconComponent = (<i className={this.props.className}>{this.props.children}</i>);

        // Users can pass in fancy stacked font awesome icons if necessary
        if (this.props.iconComponent) {
            iconComponent = this.props.iconComponent;
        }


        if (this.props.dropdownButton) {
            // react bootstrap polutes the console with stack traces and warning if there is no ID or title
            let title = '';
            if (this.props.title) {
                title = this.props.title;
            }
            const style = css`
                color:${colorIconBlack} !important;
                :hover, :focus {
                    color:${colorIconBlack} !important;
                }
            `;

            toolComponent = (
                <Dropdown
                    overlay={this.props.children}
                    trigger={['click']}
                    className={`${className} ${this.props.className} ${style}`}
                >
                    <span className="ant-dropdown-link">
                        {title} <Icon type="down" />
                    </span>
                </Dropdown>
            );
        } else if (this.props.button) {
            let title = '';
            if (this.props.title) {
                title = this.props.title;
            }

            toolComponent = <Button onClick={onClick} title={title} className={`${this.props.className}`} disabled={className === 'disabled'}>{title}</Button>;
        } else {
            let toolInnerComponent = null;
            if (this.props.textOnly) {
                toolInnerComponent = <span className={this.props.className}>{this.props.title}</span>;

            } else if (this.props.showText) {
                toolInnerComponent = (
                    <div>
                        {iconComponent}
                        <span className="icon-text">{this.props.title}</span>
                    </div>
                );

            } else {
                toolInnerComponent = iconComponent;
            }
            toolComponent = (
                <a title={this.props.title} className={className} onClick={onClick}>
                    {toolInnerComponent}
                </a>
            );
        }

        if (!this.props.enabled && this.props.disabledMessage) {
            toolComponent = (
                <Popover
                    content={this.props.disabledMessage}
                    placement="top"
                    overlayClassName={popoverErrorStyle}
                    className={css`width:100%`}
                >
                    {toolComponent}
                </Popover>
            );
        }

        return (
            <div className="toolbar-item" style={this.props.style}>
                {toolComponent}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/core/toolbar/ToolbarItem.js